import Vue from "vue";
import themeList from "./themeList";
import EventBus from '@/utils/eventBus'
import tooltip from "@/directive/tooltip";

const ThemeManager = {
    // 当前主题名称
    currentTheme: process.env.VUE_APP_THEME,

    getTooltipKey() {
        const thmemType = localStorage.getItem('theme') ? JSON.parse(localStorage.getItem('theme')) : this.currentTheme
        const getThemeType = themeList.find((item) => item.name === thmemType)?.value || 'stellar-light'
        if (getThemeType === 'stellar-light') {
            return 'dark'
        } else {
            return 'light'
        }
    },
    clearTheme() {
        localStorage.getItem('theme') && localStorage.removeItem('theme')
    },
    // 获取当前主题配置
    getTheme() {
        const thmemType = localStorage.getItem('theme') ? JSON.parse(localStorage.getItem('theme')) : this.currentTheme
        return themeList.find((item) => item.name === thmemType);
    },
    // 设置新主题
    setTheme(themeName) {
        document.body.setAttribute('theme-mode', themeName)
        localStorage.setItem('theme', JSON.stringify(themeName))
        EventBus.$emit('changeTheme', themeName)
        // if (themes[themeName]) {
        //     this.currentTheme = themeName;

        //     this._applyThemeStyles();


        //     // 保存到localStorage
        //     if (typeof localStorage !== 'undefined') {
        //         localStorage.setItem('app-theme', themeName);
        //     }

        //     return true;
        // }
        // return false;
    },
    // 应用主题到CSS变量
    _applyThemeStyles() {
        // const theme = this.getTheme();
        // const root = document.documentElement;

        // // 清除现有变量
        // Object.keys(themes.light).forEach(key => {
        //     root.style.removeProperty(`--${key}`);
        // });

        // // 应用新变量
        // Object.entries(theme).forEach(([key, value]) => {
        //     root.style.setProperty(`--${key}`, value);
        // });
    },
    // 初始化主题
    init() {
        // 优先使用用户保存的主题
        // let storedTheme = typeof localStorage !== 'undefined'
        //     ? localStorage.getItem('app-theme')
        //     : null;

        // if (storedTheme && themes[storedTheme]) {
        //     this.currentTheme = storedTheme;
        // } else {
        //     // 检测系统主题
        //     const prefersDark = window.matchMedia
        //         && window.matchMedia('(prefers-color-scheme: dark)').matches;
        //     this.currentTheme = prefersDark ? 'dark' : 'light';
        // }

        // // 应用初始主题
        // this._applyThemeStyles();

        // // 监听系统主题变化
        // if (window.matchMedia) {
        //     const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        //     mediaQuery.addListener(e => {
        //         this.setTheme(e.matches ? 'dark' : 'light');
        //     });
        // }
    }
}

// 安装插件
ThemeManager.install = function () {
    // 添加全局方法
    Vue.theme = ThemeManager;

    // 添加实例方法
    Vue.prototype.$theme = {
        // 获取当前主题配置
        get: () => ThemeManager.getTheme(),

        // 设置新主题
        set: (themeName) => ThemeManager.setTheme(themeName),

        // 获取当前主题名称
        name: () => ThemeManager.currentTheme,

        tooltipKey: () => ThemeManager.getTooltipKey(),

        // 清除主题缓存
        clear: () => ThemeManager.clearTheme()

        // 监听主题变化
        // onChanged: (callback) => {
        //     Vue.prototype.$eventBus.$on('theme-changed', callback);
        // },

        // // 停止监听主题变化
        // offChanged: (callback) => {
        //     Vue.prototype.$eventBus.$off('theme-changed', callback);
        // }
    };
};
export default ThemeManager;